const isObjectKeyHasValue = object =>
  Object.values(object).some(item => item !== null && true);

export default isObjectKeyHasValue;
